if (document.querySelector('.subdivision--video-series')) {

	// 1. This code loads the IFrame Player API code asynchronously.
	const tag = document.createElement('script');

	tag.src = "https://www.youtube.com/iframe_api";
	const firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode!.insertBefore(tag, firstScriptTag);

	function onYouTubeIframeAPIReady() {
		document.querySelectorAll(".wp-block-plaudit-youtube-playlist").forEach(block => {
			// get the initial video id from data attribute
			const playerElement = block.querySelector('.video-series__player__iframe');
			if (!playerElement) {
				return;
			}

			const initial_video_id = playerElement.getAttribute('data-initial-video');
			if (!playerElement.id) {
				playerElement.id = crypto.randomUUID();
			}

			// 2. This function creates an <iframe> (and YouTube player) after the API code downloads.
			let player = new (window as any).YT.Player(playerElement.id, {
				videoId: initial_video_id,
				playerVars: {
					'rel': 0,
					'autoplay': 0,
					'showinfo': 0,
					// 'playlist': '40oZo6JqHNs, GXgrRc5LqPc, nKmA1SZjbuo, lWPpbtH-ZsQ, C_q_7W-0RPQ, iQZ0AXsI4hc',
				}
			});

			//playlist: '40oZo6JqHNs, GXgrRc5LqPc, nKmA1SZjbuo, lWPpbtH-ZsQ, C_q_7W-0RPQ, iQZ0AXsI4hc'

			// 5. This jQuery fires when the user selects a video in the playlist
			block.querySelectorAll<HTMLElement>('.video-series__playlist__list__item')
				.forEach(ele => ele.addEventListener('click', e => {
					e.preventDefault();
					if (e.target instanceof HTMLElement) {
						player.loadVideoById(e.target.getAttribute("data-video-id"));
						block.querySelectorAll('.video-series__playlist__list__item')
							.forEach(e => e.classList.remove('video-series__playlist__list__item--selected'));
						e.target.classList.add('video-series__playlist__list__item--selected');
					}
				}));
		});
	}

	let interval = setInterval(() => {
		if ((window as any).YT) {
			clearInterval(interval);
			(window as any).YT.ready(() => onYouTubeIframeAPIReady());
		}
	}, 50);

	// 4. The API will call this function when the video player is ready.
	function onPlayerReady(event: any) {
		event.target.playVideo();
	}
}

// references:
// https://developers.google.com/youtube/iframe_api_reference#loadVideoById
